<template>
    <div class="modal fade show" aria-labelledby="addGuestModalTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                    <h1 class="mb-0">Add Guest</h1>
                    <button @click="onClickClose" type="button" class="btn-close" aria-label="Close"></button>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="col-11 py-1 mx-auto">
                        <div class="mb-1">
                            <label class="form-label"><span class="required">*</span> Full Name</label>
                            <input type="text" v-model.trim="formData.full_name" class="form-control"/>
                            <span v-if="formError.full_name" class="invalid-feedback d-block">{{ formError.full_name }}</span>
                        </div>

                        <div class="row">
                            <div class="mb-1 col-6">
                                <label class="form-label">Date of Birth/ Age</label>
                                <input type="date" v-model="formData.birthday" class="form-control"/>
                            </div>
                            <div class="mb-1 col-6">
                                <label class="form-label">Contact Number</label>
                                <input type="text" v-model.trim="formData.mobile_no" class="form-control"/>
                                <span v-if="formError.mobile_no" class="invalid-feedback d-block">{{ formError.mobile_no }}</span>
                            </div>
                        </div>

                        <div class="mb-1">
                            <label class="form-label">Address</label>
                            <input type="text" v-model.trim="formData.full_address" class="form-control"/>
                        </div>

                        <div class="row">
                            <div class="mb-1 col-6">
                                <label class="form-label">NID/ Passport No.</label>
                                <input type="text" v-model.trim="formData.nid" class="form-control"/>
                            </div>
                            <div class="mb-1 col-6">
                                <label class="form-label">Email (optional)</label>
                                <input type="email" v-model.trim="formData.email" class="form-control"/>
                            </div>
                        </div>

                        <div class="mb-1">
                            <label class="form-label">Gender</label>
                            <v-select
                                placeholder="Select Gender"
                                :options="formattedGenders"
                                v-model="formData.gender"
                                :reduce="name => name.id"
                                label="name"
                            />
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <SubmitCancelBtn @on-submit="submit" @on-cancel="onClickClose" :loading="loading"/>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import Loader from '@/components/atom/LoaderComponent';
import handleChartAccount from '@/services/modules/chartAccount';
import handleCompanyContact from '@/services/modules/companyContact';
import handleRole from '@/services/modules/role';
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { computed, inject, onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';

const emit = defineEmits(['onCreateProfile', 'onClose']);
const $route = useRoute();
const loading = ref(false);
const genders = ref({});
const { fetchHome } = handleChartAccount();
const { storeCompanyContact, storeAdditionalContactItems } = handleCompanyContact();
const { fetchCompanyDefaultRoles } = handleRole();
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const formattedGenders = computed(() => {
    return Object.keys(genders.value).map(key => ({ id: key, name: genders.value[key] }));
});

const formData = reactive({
    full_name: null,
    mobile_no: null,
    birthday: null,
    gender: null,
    nid: null,
    full_address: null,
    email: null,
    contact_type: 'person',
    profile_type: 'user',
    company_rules: [],
    company_roles_data: [],
});

const formError = reactive({
    full_name: '',
    mobile_no: '',
});

const getQuery = () => {
    return `?company_id=${$route.params.companyId}`;
};

const checkValidation = () => {
    let flag = false;
    const regex = /^(?:\+?88)?01[3-9]\d{8}$/;

    if (! formData.full_name) {
        formError.full_name = 'Full name is required';
        flag = true;
    }

    if (formData.mobile_no && ! regex.test(formData.mobile_no)) {
        formError.mobile_no = 'Invalid mobile no';
        flag = true;
    }

    return flag;
};

const saveAdditionalContactItems = async (contactId, query) => {
    const items = {
        phone: formData.mobile_no,
        email: formData.email,
    };
    await storeAdditionalContactItems(contactId, items, query).then(res => {
        if (! res.status) showError(res.message);
    });
};

const submit = async () => {
    if (checkValidation()) return;
    const query = getQuery();
    loading.value = true;
    await storeCompanyContact(formData, query).then(async (res) => {
        if (! res.status) {
            showError(res.message);
            return;
        }
        const resData = res.data;
        await saveAdditionalContactItems(resData.id, query);
        resData.mobile_no = formData.mobile_no;
        emit('onCreateProfile', resData);
        showSuccess(res.message);
    }).finally(() => {
        loading.value = false;
    });
};

const onClickClose = () => {
    emit('onClose');
};

onMounted(() => {
    const companyQuery = `?company_id=${$route.params.companyId}&roles=customer`;

    fetchHome().then(res => {
        if (res.data) genders.value = res.data.genders;
    });

    fetchCompanyDefaultRoles(companyQuery).then(res => {
        if (! res.data) return;
        res.data.map(item => {
            formData.company_rules.push(item.id);
            formData.company_roles_data.push({ id: item.id, serial_no: '' });
        });
    });
});
</script>
